// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*размер кнопки помощи поменьше*/
.stripes-mainsubtitle {
  font-family: "Amatic SC";
  font-size: 3vw;
  text-align: center;
  margin-top: 0;
  width: 58vw;
}
.stripes-message-bar {
  margin: 5px;
  display: grid;
  background: #ffffff;
  border: 1.5px solid #1a6a7c;
  border-radius: 3vh;
  text-align: center;
  padding: 5px;
  color: #1a6a7c;
  font-size: 1.5vw;
}
.Stripes-Board {
  display: grid;
  grid-template-rows: auto 1fr auto;
  gap: 1vh;
}
.stripes-top-bar {
  display: grid;
  grid-template-columns: auto 3vw;
  width: 59vw;
  gap: 0.5vw;
}
.stripes-helpbut{
  cursor: pointer;
  display: grid;
  place-items: center;
}
#s-button{
  height: 85%;
}
.stripes-scene {
  display: grid;
  grid-template-columns: 24vw auto auto;
  gap: 1vw;
}
.stripes-boxout {
  display: grid;
  background: #ffffff;
  border: 2px solid #1a6a7c;
  height: max-content;
}
.stripes-boxin {
  display: grid;
  min-width: 33vw;
  background: rgb(227, 241, 250);
  border: 2px solid #1a6a7c;
}

/* div полосок */
.s-strips {
  display: grid;
  width: 100%;
  place-items: center;
}
/* полоски перемещенные-правильные */
.StripsIn.correct-position {
  border: 2px solid #50c854 !important;
  box-sizing: border-box;
  pointer-events: none;
}
/* img полосок */

.StripsIn {
  border: 1px solid #1a6a7c;
  box-sizing: border-box;
  width: 100%;
}
.imgstripes {
  cursor: grab;
}
.startpic {
  display: grid;
  border: 1px solid #1a6a7c;
  height: max-content;
  pointer-events: none;
}
.s-picture {
  width: 100%;
}
#s-win_img {
  width: 100%;
  opacity: 0;
  transform: scale(0.2);
  animation: centerAppear 5s ease forwards;
  will-change: transform, opacity;
  backface-visibility: hidden;
  transform-origin: center center; 
}
@keyframes centerAppear {
  from {
    opacity: 0;
    transform: scale(0.2);
  }
  to {
    opacity: 1;
    transform: scale(1);
  }
}
`, "",{"version":3,"sources":["webpack://./src/TaskWindows/StripesApp/styles/StripesBoard.css"],"names":[],"mappings":"AAAA,gCAAgC;AAChC;EACE,wBAAwB;EACxB,cAAc;EACd,kBAAkB;EAClB,aAAa;EACb,WAAW;AACb;AACA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,2BAA2B;EAC3B,kBAAkB;EAClB,kBAAkB;EAClB,YAAY;EACZ,cAAc;EACd,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,iCAAiC;EACjC,QAAQ;AACV;AACA;EACE,aAAa;EACb,+BAA+B;EAC/B,WAAW;EACX,UAAU;AACZ;AACA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;AACrB;AACA;EACE,WAAW;AACb;AACA;EACE,aAAa;EACb,qCAAqC;EACrC,QAAQ;AACV;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,mBAAmB;AACrB;AACA;EACE,aAAa;EACb,eAAe;EACf,8BAA8B;EAC9B,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,WAAW;EACX,mBAAmB;AACrB;AACA,oCAAoC;AACpC;EACE,oCAAoC;EACpC,sBAAsB;EACtB,oBAAoB;AACtB;AACA,gBAAgB;;AAEhB;EACE,yBAAyB;EACzB,sBAAsB;EACtB,WAAW;AACb;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,oBAAoB;AACtB;AACA;EACE,WAAW;AACb;AACA;EACE,WAAW;EACX,UAAU;EACV,qBAAqB;EACrB,wCAAwC;EACxC,+BAA+B;EAC/B,2BAA2B;EAC3B,+BAA+B;AACjC;AACA;EACE;IACE,UAAU;IACV,qBAAqB;EACvB;EACA;IACE,UAAU;IACV,mBAAmB;EACrB;AACF","sourcesContent":["/*размер кнопки помощи поменьше*/\n.stripes-mainsubtitle {\n  font-family: \"Amatic SC\";\n  font-size: 3vw;\n  text-align: center;\n  margin-top: 0;\n  width: 58vw;\n}\n.stripes-message-bar {\n  margin: 5px;\n  display: grid;\n  background: #ffffff;\n  border: 1.5px solid #1a6a7c;\n  border-radius: 3vh;\n  text-align: center;\n  padding: 5px;\n  color: #1a6a7c;\n  font-size: 1.5vw;\n}\n.Stripes-Board {\n  display: grid;\n  grid-template-rows: auto 1fr auto;\n  gap: 1vh;\n}\n.stripes-top-bar {\n  display: grid;\n  grid-template-columns: auto 3vw;\n  width: 59vw;\n  gap: 0.5vw;\n}\n.stripes-helpbut{\n  cursor: pointer;\n  display: grid;\n  place-items: center;\n}\n#s-button{\n  height: 85%;\n}\n.stripes-scene {\n  display: grid;\n  grid-template-columns: 24vw auto auto;\n  gap: 1vw;\n}\n.stripes-boxout {\n  display: grid;\n  background: #ffffff;\n  border: 2px solid #1a6a7c;\n  height: max-content;\n}\n.stripes-boxin {\n  display: grid;\n  min-width: 33vw;\n  background: rgb(227, 241, 250);\n  border: 2px solid #1a6a7c;\n}\n\n/* div полосок */\n.s-strips {\n  display: grid;\n  width: 100%;\n  place-items: center;\n}\n/* полоски перемещенные-правильные */\n.StripsIn.correct-position {\n  border: 2px solid #50c854 !important;\n  box-sizing: border-box;\n  pointer-events: none;\n}\n/* img полосок */\n\n.StripsIn {\n  border: 1px solid #1a6a7c;\n  box-sizing: border-box;\n  width: 100%;\n}\n.imgstripes {\n  cursor: grab;\n}\n.startpic {\n  display: grid;\n  border: 1px solid #1a6a7c;\n  height: max-content;\n  pointer-events: none;\n}\n.s-picture {\n  width: 100%;\n}\n#s-win_img {\n  width: 100%;\n  opacity: 0;\n  transform: scale(0.2);\n  animation: centerAppear 5s ease forwards;\n  will-change: transform, opacity;\n  backface-visibility: hidden;\n  transform-origin: center center; \n}\n@keyframes centerAppear {\n  from {\n    opacity: 0;\n    transform: scale(0.2);\n  }\n  to {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
